<template>
    <div class="tower-selector">
        <div class="tabs">
            <div
                v-for="(tab, i) in tabs"
                :key="`tab${i}`"
                :class="{
                    actived: tabSelected === `game${tab.type}`,
                }"
                @click="onChangGame(`game${tab.type}`)"
            >
                {{ tab.label }}
            </div>
        </div>
        <div class="select-level">
            <div class="selected">
                {{ levels[tabSelected][levelSelected - 1].label }}
            </div>
            <select v-model="levelSelected" @change="onChange(levelSelected)">
                <option
                    v-for="(level, i) in levels[tabSelected]"
                    :key="`level${i + 1}`"
                    :value="`${i + 1}`"
                >
                    {{ level.label }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: [
                {
                    label: '含醣食物大挑戰',
                    type: 1,
                },
                {
                    label: '糖尿病知識大挑戰',
                    type: 2,
                },
            ],
            levels: {
                game1: [
                    {
                        label: '（易）海王宮',
                    },
                    {
                        label: '（中）冰雪村',
                    },
                    {
                        label: '（難）太空城',
                    },
                ],
                game2: [
                    {
                        label: '（易）青山塔',
                    },
                    {
                        label: '（中）探索村',
                    },
                    {
                        label: '（難）魔法城',
                    },
                ],
            },

            tabSelected: '',
            levelSelected: '1',
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.levelSelected = this.$route.params.level;
            this.tabSelected = this.$route.params.type;
        },
        onChange(tab) {
            if (tab.match(/game/)) {
                this.$router.replace({ params: { type: tab } });
            } else this.$router.replace({ params: { level: tab } });
        },
        onChangGame(tab) {
            if (this.tabSelected === tab) return;
            this.tabSelected = tab;
            this.onChange(tab);
        },
    },
};
</script>

<style lang="scss" scoped>
.tower-selector {
    margin-top: -40px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tabs {
        max-width: 300px;
        margin-top: 20px;
        color: #fff;
        display: flex;
        > * {
            font-size: 14px;
            height: 30px;
            cursor: pointer;
            padding: 3px 20px;
            background-color: #bbb;
            border-radius: 30.1px;
            font-weight: bold;
            &:first-child {
                margin-right: 10px;
            }
        }
        .actived {
            background-color: #f68d36;
        }
    }
    .select-level {
        margin-top: 10px;
        position: relative;
        width: 100%;
        max-width: 300px;
        height: 30px;
        border-radius: 30.1px;
        background-color: #56a2e6;
        display: flex;
        .selected {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-weight: bold;
            text-align: center;
        }
        select {
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
            &:focus {
                border: 0;
                outline: 0px;
            }
            &:focus-visible {
                outline: 0px;
            }
        }
    }
    @media screen and (max-width: 320px) {
        margin-top: -20px;
    }
}
</style>
